import React from 'react';
import QuizTemplate from './QuizTemplate';

function QuizPatentSearch({pb}) {
   const questions = [
      {
        questionText: 'Why are patents useful?',
        answerOptions: [
          { answerText: 'Patents protect the rights of inventors', isCorrect: false },
          { answerText: 'Patents help you check if an idea already exists', isCorrect: false },
          { answerText: 'All of the above', isCorrect: true },
        ],
      },
      {
        questionText: 'How can you quickly check if an idea is patented?',
        answerOptions: [
          { answerText: 'Read through the whole patent', isCorrect: false },
          { answerText: 'Look at the abstract and pictures from the patent', isCorrect: true },
          { answerText: 'Ask a friend', isCorrect: false },
        ],
      },
    ]

    return(
      <div className="m-3">
         <QuizTemplate data={questions} problem={pb} />
      </div>
    )

}

export default QuizPatentSearch;